import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useCallback, useMemo } from 'react';
import { observer } from 'mobx-react';
import Avatar from '@/common/components/Avatar/Avatar';
import Button, { SIZE_SMALL } from '@/common/components/Button/Button';
import Icon from '@/common/components/Icon/Icon';
import FancySelect from '@/common/components/inputs/FancySelect/FancySelect';
import { usePrivateAccessModalStore } from '@/security/components/PrivateAccessModal/PrivateAccessModalStore';
import { getDataAccessById, getDataAccessesByType, getDataAccessIcon } from '@/security/constants/dataAccess';
import { MIXED_DATA_ACCESS } from '@/security/types/PrivateAccessProfile';
import styles from './ProfileItem.module.less';
function ProfileItem(props) {
    const { profile } = props;
    const { changeAssigneeAccess, unselectAssignee, targetType, canChangeCutDataAccess, isUpdating } = usePrivateAccessModalStore();
    const dataAccessOptions = useMemo(() => {
        let accessOptions = getDataAccessesByType(targetType).map((level) => ({
            value: level.id,
            label: level.title,
            icon: level.icon,
            description: level.description,
        }));
        accessOptions = accessOptions.filter((option) => {
            const isCurrentDataAccess = option.value === profile.dataAccess;
            return !isCurrentDataAccess;
        });
        accessOptions.push({
            value: 'remove',
            label: 'Remove Access',
            icon: 'close',
            className: styles.personalAccessOptionRemove,
        });
        return accessOptions;
    }, [targetType, profile.dataAccess]);
    const onChange = useCallback((option) => {
        if (!option) {
            return;
        }
        const value = option[0].value;
        if (value === 'remove') {
            unselectAssignee(profile.assignee.getAssigneeId());
            return;
        }
        changeAssigneeAccess(profile.assignee.getAssigneeId(), value);
    }, [profile.assignee.getAssigneeId()]);
    return (_jsx(FancySelect, { className: styles.personalAccessUser, hideArrow: true, disabled: isUpdating, onChange: onChange, options: dataAccessOptions, renderPlaceholder: () => (_jsxs("div", { className: styles.personalAccessUserContent, children: [_jsx("div", { children: _jsx(Avatar, { className: styles.personalAccessAvatar, size: "large", username: profile.assignee.name }) }), _jsxs("div", { className: styles.personalAccessDescription, children: [_jsx("div", { children: profile.assignee.name }), canChangeCutDataAccess && (_jsx("div", { className: styles.personalAccessDescriptionAccess, children: profile.dataAccess !== MIXED_DATA_ACCESS ? (_jsxs(Fragment, { children: [_jsx(Icon, { className: styles.dataAccessIcon, name: getDataAccessIcon(profile.dataAccess, targetType) }), _jsx("span", { className: styles.personalAccessDescriptionName, children: getDataAccessById(profile.dataAccess, targetType)?.title })] })) : (_jsx("span", { className: styles.personalAccessDescriptionName, children: "Mixed Cut Data Access" })) }))] }), _jsx(Button, { color: "transparent", size: SIZE_SMALL, withIcon: true, children: _jsx(Icon, { name: "more" }) })] })), styles: {
            valueContainer: (base) => ({
                ...base,
                padding: 0,
                flexWrap: 'nowrap',
            }),
        } }));
}
export default observer(ProfileItem);
